import _ from 'lodash'

function getLicence(user) {
  return user.licence_configuration.base_template.code
}

function getOrganization(user) {
  return _.maxBy(user.organizations, v => v.priority).organization.code
}

export { getLicence, getOrganization }
